exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".title-header[data-v-4cfbf695]{font-size:18px;text-align:center;left:0;color:#205c43}#tab-item[data-v-4cfbf695]{min-width:20px}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Pages/landing.vue"],"names":[],"mappings":"AACA,+BACE,eAAgB,AAChB,kBAAmB,AACnB,OAAQ,AACR,aAAe,CAChB,AACD,2BACE,cAAgB,CACjB","file":"landing.vue","sourcesContent":["\n.title-header[data-v-4cfbf695] {\n  font-size: 18px;\n  text-align: center;\n  left: 0;\n  color: #205c43;\n}\n#tab-item[data-v-4cfbf695] {\n  min-width: 20px;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4cfbf695","scoped":true,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/admin/settings/Pages/landing.vue
// module id = 1383
// module chunks = 2